module.exports = __webpack_public_path__ + "987bbdc2c64934b19ee0115cc24c252b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/outer-circle.png
// module id = TTQx
// module chunks = 0